<div class="terms-of-service-wrapper">
  <div class="glow green"></div>
  <div class="glow purple"></div>
  <h1>Terms of Service</h1>
  <p><strong>Effective Date:</strong> April 3, 2025</p>

  <h2>1. Introduction</h2>
  <p>
    Welcome to HTML Arcade, an interactive skill-based gaming platform. These Terms of Service constitute a legally binding agreement between you and HTML Arcade.
    By using the platform, you agree to these Terms and our Privacy Policy. If you disagree, you must stop using the platform.
  </p>

  <h2>2. Eligibility and Scope of Use</h2>
  <ul>
    <li>Must be 18+ or of legal majority in your region.</li>
    <li>Platform intended for U.S. residents only.</li>
    <li>Restricted access from jurisdictions prohibiting skill-based gaming.</li>
  </ul>

  <h2>3. Account Creation and Management</h2>
  <ul>
    <li>Users must provide accurate information during registration.</li>
    <li>Users are responsible for account security.</li>
    <li>Accounts may be suspended or terminated for violations.</li>
  </ul>

  <h2>4. Virtual Points and Coins</h2>
  <ul>
    <li>Points are purchased and non-refundable.</li>
    <li>Coins are earned through gameplay and have no real-world value.</li>
    <li>Points and Coins are non-transferable and belong to HTML Arcade.</li>
  </ul>

  <h2>5. Prohibited Conduct</h2>
  <ul>
    <li>No exploiting, hacking, or reverse engineering.</li>
    <li>No use of bots, cheats, or automation tools.</li>
    <li>No abusive, fraudulent, or unlawful activity.</li>
  </ul>

  <h2>6. Payments and Disputes</h2>
  <ul>
    <li>Payments via authorized processors only (e.g., PayPal, Stripe).</li>
    <li>All sales final; chargebacks may lead to suspension.</li>
    <li>Disputes must be submitted in writing within 7 business days.</li>
  </ul>

  <h2>7. Privacy and Data Security</h2>
  <ul>
    <li>Data collected includes personal and usage information.</li>
    <li>We apply AES-256 encryption and secure infrastructure.</li>
    <li>Users can access, correct, or delete their data.</li>
  </ul>

  <h2>8. Intellectual Property</h2>
  <ul>
    <li>All content is owned by HTML Arcade or its licensors.</li>
    <li>You may not use, copy, or modify content without consent.</li>
  </ul>

  <h2>9. Limitation of Liability</h2>
  <ul>
    <li>HTML Arcade is not liable for indirect or incidental damages.</li>
    <li>Liability is capped at Points/Coins purchased in the last 90 days.</li>
  </ul>

  <h2>10. Dispute Resolution</h2>
  <ul>
    <li>Binding arbitration for most disputes (AAA rules).</li>
    <li>Governing law: State of Virginia, USA.</li>
  </ul>

  <h2>11. Amendments</h2>
  <ul>
    <li>Terms may be updated with notice.</li>
    <li>Continued use = acceptance of updated Terms.</li>
  </ul>

  <h2>12. Termination</h2>
  <ul>
    <li>We may suspend or terminate accounts for any violation.</li>
    <li>All Points and Coins are forfeited upon termination.</li>
  </ul>

  <h2>13. Contact Information</h2>
  <p>
    Email: <a href="mailto:sibi@sibicba.com">sibi&#64;sibicba.com</a><br />
    Address: 5132 Topping Lane, Glen Allen, VA 23060
  </p>
</div>
